import { get, post, put } from './client';

/**
 * 
 * @param {*} data 
 * @returns 
 */
export function postCourse(data) {
    return post('course/V2', data);
}

/**
 * 
 * @param {*} id
 * @returns 
 */
export function getOneCourse(id) {
    return get('course/' + id);
}

/**
 * 
 * @param {*} pickup 
 * @param {*} delivery 
 * @returns 
 */
export function getDistance(pickup, delivery) {
    let url = 'course/distance?origin=' + pickup + '&destination=' + delivery + '&mode=bicycling';
    return get(url);
}


/**
 * 
 * @param {*} pickupLat 
 * @param {*} pickupLng 
 * @param {*} deliveryLat 
 * @param {*} deliveryLng 
 * @returns 
 */
export function getDeliveryLocationAllowed(pickupLat, pickupLng, deliveryLat, deliveryLng) {
    let url = 'course/deliverylocation/allowed?pickupLocation[]=' + pickupLat + '&pickupLocation[]=' + pickupLng
        + '&deliveryLocation[]=' + deliveryLat + '&deliveryLocation[]=' + deliveryLng;

    return get(url);
}

/**
 * 
 * @param {*} distance 
 * @param {*} tranports 
 * @param {*} packet_price 
 * @param {*} packet_weight 
 * @param {*} collectDateTime 
 * @returns 
 */
export function getPrice(distance, tranports, packet_price, packet_weight, collectDateTime, deliveryOptions) {
    let url = 'course/price?distance=' + distance + '&transports=' + tranports + '&weight='
        + packet_weight + '&packetPrice=' + packet_price + '&collectDateTime=' + collectDateTime;

    deliveryOptions.forEach((deliveryOption) => {
        url = url + "&deliveryOptions[]=" + deliveryOption;
    });

    return get(url);
}

/**
 * 
 * @param {*} data 
 * @returns 
 */
export function checkRules(data) {
    return post('course/checkrules', data);
}

/**
 * 
 * @param {number} page
 * @param {number} limit
 * @param {Object} payload
 * @returns
 */
export function getAll(page, limit, payload) {
    let url = 'courses?page=' + page + '&limit=' + limit;

    return post(url, payload);
}

/**
 *
 * @param {number} page
 * @param {number} limit
 * @param {*} payload
 * @returns
 */
export function getTransport(data) {
    return post('course/transport', data);
}

/**
 *
 * @param {*} id
 * @param {*} confirm
 * @returns
 */
export function validateCourse(id, confirm) {
    let url = 'course/' + id + '/validate';
    return put(url, confirm);
}

/**
 *
 * @returns
 */
export function getOpeningSchedules() {
    return get('course/openingschedules');
}
